import { render } from "./Change-Password-Confirmation.vue?vue&type=template&id=062f613a&scoped=true"
import script from "./Change-Password-Confirmation.vue?vue&type=script&lang=js"
export * from "./Change-Password-Confirmation.vue?vue&type=script&lang=js"

import "./Change-Password-Confirmation.vue?vue&type=style&index=0&id=062f613a&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-062f613a"]])

export default __exports__